import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import isNull from '../../../../../utils/NullChecking';
import DatePicker from '../../../../General/DatePicker';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import Loader from '../../../../shared/Loader/Loader';
import { useSelector } from 'react-redux';
import { convertDateToYYYYMMDD, getDayName, TotalTimeArray } from '../../../../../utils/Constants';
import CalendaRangeInput from '../../../../General/CalendarRangeInput';
import InitialLetters from '../../../../../utils/InitialLetters';
import { isFemale, isMale } from '../../../../../utils/Gender';
import SuperSearchList from '../../../../shared/SuperSearch/SuperSearchList';
import FormValidator from '../../../../../utils/FormValidator';
import DeleteConfirmatiom from '../../../../General/DeleteConfirmation';
import moment from 'moment/moment';
import AddMissedVisitPopup from '../AddMissedVisitPopup/AddMissedVisitPopup';

const DaySchedulePopup = (props) => {

    const { isMasterWeekOpen, onClose, onCloseSave, ID, patientID, data } = { ...props }
    const API_URL = enumUtil.controller.AuthScheduler;
    const API_URL_PATIENT = enumUtil.controller.Patient
    const API_URL_GENERAL = enumUtil.controller.General
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const practiceType = DropDowns.PracticeType

    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    let currentDate = new Date();
    let Zone = currentDate.toString().split(' ').slice(5).join(' ')

    let Master_Week_Modal = {
        PatientAuthorizationID: '',
        SchedulePeriod: 'One Week',
        ProcedureCodeID: '',
        DateFrom: null,
        isSplitShift: false,
        DateTo: null,
    }

    let Master_Week_Schedule = {
        AppointmentDate: "",
        AppointmentEnd: "",
        AppointmentStart: "",
        CareGiver: "",
        CareGiverID: "",
        ClaimID: "",
        InsuranceID: "",
        InsuranceName: "",
        LocationID: "",
        PatientAppointmentID: "",
        PatientAuthorization: "",
        PatientAuthorizationID: "",
        PatientID: "",
        ProviderID: "",
        MissVisitStatus: "",
        IsMissVisit: false,
    }

    let Save_Master_Week_Schedule = {
        Auth: {
            Shifts: []
        }
    }

    let Patient_Detail_Modal = {
        Age: "",
        DOB: "",
        Gender: "",
        LocationID: "",
        MedicaidNo: "",
        Name: "",
        PatientID: "",
        InsuranceID: "",
        InsuranceName: "",
        PatientInsuranceID: "",
        ProfilePictureURL: "",
    }

    const Search_Data = {
        DateFrom: '',
        DateTo: '',
    }

    let Validation_Modal = {
        PatientAuthorizationID: '',
    }


    let Schedule_Validation_Modal = {
        "StartTime": "",
        "EndTime": "",
    }

    let Schedule_Val_Modal = {}

    let Schedule_Val_Shift_Modal = {}

    const [isOpenHistory, setIsOpenHistory] = useState(false);
    const [PatientAppointmentID, setPatientAppointmentID] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [mainModalMasterWeek, setMainModalMasterWeek] = useState(Master_Week_Modal);
    const [saveModalMasterWeek, setSaveModalMasterWeek] = useState({});
    const [mainModalMasterWeekSchedule, setMainModalMasterWeekSchedule] = useState(Master_Week_Schedule)
    const [saveModalMasterWeekSchedule, setSaveModalMasterWeekSchedule] = useState(Master_Week_Schedule)
    const [CareGiverDD, setCareGiverDD] = useState([]);

    const [MasterScheduleValidationModal, setMasterScheduleValidationModal] = useState(Schedule_Validation_Modal)
    const [searchParam, setSearchParam] = useState(Search_Data);
    const [PatientDetails, setPatientDetails] = useState(Patient_Detail_Modal);
    const [AuthDropDown, setAuthDropDown] = useState([]);
    const [AuthDD, setAuthDD] = useState([]);
    const [InsuranceEditable, setInsuranceEditable] = useState(false)
    const [InsuranceDropDown, setInsuranceDropDown] = useState([])
    const [dateRange, setDateRange] = useState(null);
    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [DelID, setDelID] = useState(0)
    const [masterWeekData, setMasterWeekData] = useState({});
    const [ScheduleShiftValidation, setScheduleShiftValidation] = useState({})
    const [ShowAll, setShowAll] = useState(false)
    const [DaysSelected, setDaysSelected] = useState([]);
    const [ViewMode, setViewMode] = useState(false);
    const [IsRecordExist, setIsRecordExist] = useState(false);
    const [HistoryRecord, setHistoryRecord] = useState([]);
    const [openMissedVisit, setOpenMissedVisit] = useState(false);
    const [MissedVisit, setMissedVisit] = useState(false);
    const [isDayPassed, setIsDayPassed] = useState(false)
    // useEffect(() => {
    //     if (!isNull(ID)) {
    //         // set
    //     }
    // }, [ID])

    /////  handle on change functions /////
    const handleMissedVisit = (name, checked) => {
        if (name === "IsMissVisit" && checked) {
            setOpenMissedVisit(true)
        }
    }
    const handleOnChangeFilters = (e) => {
        const { name, value } = e.target
        let modal = { ...mainModalMasterWeek };
        let saveModal = { ...saveModalMasterWeek };
        modal[name] = value;
        setMainModalMasterWeek(modal);
        for (let property in Master_Week_Modal) {
            if (name === property) {
                saveModal[property] = value;
            }
        }
        setSaveModalMasterWeek(saveModal);
    }
    const handleOnChangeSchedule = (e, isChecked) => {
        const { name, value, checked } = e.target
        let modal = { ...mainModalMasterWeekSchedule };
        let saveModal = { ...saveModalMasterWeekSchedule };

        if (isChecked) {
            modal[name] = checked;

            handleMissedVisit(name, checked);
        }
        else {
            modal[name] = value;
        }

        setMainModalMasterWeekSchedule(modal);
        for (let property in Master_Week_Schedule) {
            if (name === property) {
                if (isChecked) {
                    saveModal[name] = checked;
                    if (!checked) {
                        saveModal["MissVisitStatus"] = "";
                    }
                } else {
                    saveModal[name] = value;
                }
            }
        }
        setSaveModalMasterWeekSchedule(saveModal);
    }

    const handleScheduleShiftsSelectedData = (selectedData, name, type) => {

        let modal = { ...mainModalMasterWeekSchedule };
        let saveModal = { ...saveModalMasterWeekSchedule };

        if (name === `AppointmentStart`) {
            if (!isNull(modal[`AppointmentEnd`])) {

                let comparison = compareTimes(selectedData?.value, modal[`AppointmentEnd`])

                if (!comparison) {
                    modal[`AppointmentEnd`] = ''
                }

                // calculateScheduledShiftsUnits(selectedData?.value, modal[`AppointmentEnd`], modal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], name.slice(0, 3), index)
            }
            // else {
            //     if (BillingEntityID == '2') {
            //         let updatedTime = calculateUnitsHours(modal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], selectedData?.value, name.slice(0, 3));
            //         if (updatedTime) {
            //             modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = updatedTime
            //         }
            //         calculateScheduledShiftsUnits(selectedData?.value, updatedTime, modal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], name.slice(0, 3), index)

            //     }

            // }
            // modal['Auth']['Shifts'][index][`${name.slice(0, 3)}Checked`] = true;
        }
        // if (name === `AppointmentEnd`) {
        //     if (!isNull(modal[`AppointmentStart`])) {
        //         calculateScheduledShiftsUnits(modal[`AppointmentStart`], selectedData?.value, modal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], name.slice(0, 3), index)
        //     }
        // }
        if (name === `CareGiverID`) {
            modal[`CareGiver`] = selectedData?.display;
        }
        modal[name] = selectedData?.value;


        setMainModalMasterWeekSchedule(modal);
        for (let property in Master_Week_Schedule) {
            if (name === property) {

                if (name === `AppointmentStart`) {
                    if (!isNull(saveModal[`AppointmentEnd`])) {
                        let comparison = compareTimes(selectedData?.value, saveModal[`AppointmentEnd`])

                        if (!comparison) {
                            saveModal[`AppointmentEnd`] = ''
                        }
                    }
                    // if (BillingEntityID == '2') {
                    //     let updatedTime = calculateUnitsHours(saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], selectedData?.value, name.slice(0, 3));
                    //     if (updatedTime) {
                    //         saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = updatedTime
                    //     }

                    // }
                    // saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}Checked`] = true;
                }
                if (name === `CaregiverID`) {
                    saveModal[`CareGiver`] = selectedData?.display;
                }
                saveModal[property] = selectedData?.value;

            }
        }

        setSaveModalMasterWeekSchedule(saveModal);

    }

    /// Validations /// 

    const formScheduleValidation = () => {
        let validationModal = {

            "MonStartTime": FormValidator(mainModalMasterWeekSchedule?.AppointmentStart, enumUtil.enumValidationType.Required, ''),
            "MonEndTime": FormValidator(mainModalMasterWeekSchedule?.AppointmentEnd, enumUtil.enumValidationType.Required, ''),
            // "MonCaregiverID": (mainModalMasterWeekSchedule?.["Auth"]?.MonChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.MonCaregiverID, enumUtil.enumValidationType.Required, '')),
        }
        setMasterScheduleValidationModal(validationModal)
        Schedule_Val_Modal = validationModal
    }

    /// functionalities ///

    const PropertyNullCheck = (modal) => {
        Object.keys(modal).forEach((key) => {
            if (key.includes("CaregiverID") && (modal[key] === "" || modal[key] === "-1")) {

                modal[key] = IsRecordExist ? "-99" : null;
            }
        })

        modal.Shifts.forEach((item) => {
            Object.keys(item).forEach((key) => {
                if (key.includes("CaregiverID") && (item[key] === "" || modal[key] === "-1")) {
                    item[key] = IsRecordExist ? "-99" : null;
                }
            })
        })

        return modal;
    }

    // const handleCareGiverByDefault = (modal, obj, type) => {

    //     Object.keys(modal).map((item) => {
    //         if (item.includes('CaregiverID')) {
    //             modal[item] = obj?.value;
    //         }
    //     })

    //     modal?.Shifts?.map((Shift) => {
    //         Object.keys(Shift).map((item) => {
    //             if (item.includes('CaregiverID')) {
    //                 Shift[item] = obj?.value;
    //             }
    //         })
    //     })

    //     return modal
    // }

    // function getDaysBetween(startDate, endDate) {
    //     const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    //     const start = new Date(startDate);
    //     const end = new Date(endDate);

    //     // Calculate the difference in days
    //     const differenceInTime = end.getTime() - start.getTime();
    //     const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    //     // Check if the difference is less than or equal to 7 days
    //     if (differenceInDays <= 6) {
    //         const daysBetween = [];

    //         for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    //             const dayName = dayNames[d.getDay()];  // Get the day name
    //             const dayNumber = d.getDate();         // Get the day number
    //             daysBetween.push({ dayName, dayNumber });
    //         }

    //         return daysBetween;
    //     } else {
    //         return [];
    //     }
    // }

    const handleEditMode = (e) => {
        setViewMode(!ViewMode);
    }

    function convertTo24Hour(time) {
        const [timePart, modifier] = time.split(" ");
        let [hours, minutes] = timePart.split(":").map(Number);

        if (modifier === "PM" && hours !== 12) {
            hours += 12;
        }
        if (modifier === "AM" && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    }

    function compareTimes(time1, time2) {
        if (!isNull(time1)) {

            const time1Obj = convertTo24Hour(time1);
            const time2Obj = convertTo24Hour(time2);

            const date1 = new Date();
            const date2 = new Date();

            date1.setHours(time1Obj.hours, time1Obj.minutes);
            date2.setHours(time2Obj.hours, time2Obj.minutes);

            // Compare times
            if (date2.getTime() > date1.getTime()) {
                return time2;
            }

        }
        else {
            return time2
        }
    }

    const FormValidatorArray = (list) => {
        let result = false
        if (list && list.length > 0) {
            list.map((item) => {
                Object.keys(item)?.map((key) => {
                    if (!isNull(item[key])) {
                        result = true
                    }
                })
            })
        }
        return result
    }

    /// Save Modal ///
    const handleSaveMasterWeek = () => {

        if (practiceType !== "Adult Day Care") {
            formScheduleValidation()
        }


        let validationSchedule = FormValidator([Schedule_Val_Modal], enumUtil.enumValidationType.NullCheck)


        if (validationSchedule) {
            return
        }
        else {
            let saveModal = {
                "TableName": enumUtil.enumAPITableName.PatientAppointment,
                "ID": PatientAppointmentID,
                "DATA": {
                    "AppointmentStart": saveModalMasterWeekSchedule?.AppointmentStart,
                    // "AppointmentStartTime": saveModalMasterWeekSchedule?.AppointmentStartTime,
                    "AppointmentEnd": saveModalMasterWeekSchedule?.AppointmentEnd,
                    // "AppointmentEndTime": saveModalMasterWeekSchedule?.AppointmentEndTime,
                    "AppointmentDate": saveModalMasterWeekSchedule?.AppointmentDate,
                    "CareGiverID": saveModalMasterWeekSchedule?.CareGiverID ? saveModalMasterWeekSchedule?.CareGiverID + "" : "-99",
                    "PatientAuthorizationID": saveModalMasterWeekSchedule?.PatientAuthorizationID + "",
                    "MissVisitStatus": saveModalMasterWeekSchedule?.MissVisitStatus + "",
                    "IsMissVisit": saveModalMasterWeekSchedule?.IsMissVisit + "",
                }
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL_PATIENT + '/SaveSingleRecord', 'post', saveModal).then((response) => {
                setIsLoading(false);
                onCloseSave()
                NotificationHandler("Record Saved Successfully", enumUtil.enumtoaster.success)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error)
            })
        }
    }

    const handleDelete = (ID) => {
        setDelID(ID);
        setIsOpenAlert(true);
    }

    const onDeleteClose = () => {
        setIsOpenAlert(false);
    }

    const onCloseDelete = () => {
        setIsOpenAlert(false);
        onCloseSave();
    }

    let DeleteConfirmation = ''
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onClose={onDeleteClose} onCloseDelete={onCloseDelete} API_URL={API_URL_PATIENT} TableName={enumUtil.enumAPITableName.PatientAppointment} ID={DelID} Messsage={true} hideReason={true} />
    }

    const onCloseMissedPopup = () => {
        setOpenMissedVisit(false);
        setMainModalMasterWeekSchedule({ ...mainModalMasterWeekSchedule, IsMissVisit: false })
    }

    const onCloseSaveMissedPopup = () => {
        setOpenMissedVisit(false)
    }

    let MissedVisitPopup = "";
    if (openMissedVisit) {
        MissedVisitPopup = <AddMissedVisitPopup openPopup={openMissedVisit} onClose={onCloseMissedPopup} onCloseSave={onCloseSaveMissedPopup} name={'MissVisitStatus'} searchParam={saveModalMasterWeekSchedule} setSearchParam={setSaveModalMasterWeekSchedule} />
    }

    const handleDateComparison = (date) => {
        let currentDate = new Date()
        if (!isNull(date)) {
            let formattedDate = new Date(date);
            if (formattedDate < currentDate) {
                setIsDayPassed(true);
            } else {
                setIsDayPassed(false);
            }
        }
    }

    // useEffect(() => {
    //     if (mainModalMasterWeek?.PatientAuthorizationID) {
    //         LoadData()

    //     }
    // }, [mainModalMasterWeek?.PatientAuthorizationID])

    /// useEffects ///
    useEffect(() => {

        if (!isNull(patientID)) {
            console.log("patientID", patientID);
            setAuthDropDown([]);
            setInsuranceDropDown([])
            setPatientDetails({});
            setIsLoading(true);
            ServerRequestProtected(API_URL + "/PatientAuthDropDown", 'post', {

                "ID": patientID,
                "TableName": enumUtil.enumAPITableName.MasterWeekSchedule,

            }).then((response) => {

                let patientDetails = response?.PatientDetails;
                let AuthDD = response?.PatientAuthDetails;
                let InsuranceDD = response?.InsuranceINFO;

                setAuthDD(AuthDD ? AuthDD.filter((item) => {
                    return !isNull(item?.PatientInsuranceID);
                }) : []);

                setAuthDropDown(AuthDD ? AuthDD.filter((item) => {
                    return parseInt(item?.PatientInsuranceID) === parseInt(response?.PatientDetails?.PatientInsuranceID) && !isNull(item?.ProcedureCodeID);
                }) : []);

                setPatientDetails(patientDetails ? patientDetails : {});
                setInsuranceDropDown(InsuranceDD ? InsuranceDD : []);
                setIsLoading(false);

            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            });
            ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {

                "ID": patientID,
                "TableName": enumUtil.enumAPITableName.PATIENTCAREGIVERS,

            }).then((response) => {
                setCareGiverDD(response)

            }).catch((error) => {
                setIsLoading(false);
                // NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            });
        }
    }, [patientID]);

    useEffect(() => {
        if (!isNull(ID)) {
            setPatientAppointmentID(ID);
            setIsLoading(true);
            ServerRequestProtected(API_URL_PATIENT + "/FindSingleRecord", 'post', {

                "ID": ID,
                "TableName": enumUtil.enumAPITableName.PatientAppointment,

            }).then((response) => {
                setMainModalMasterWeekSchedule(response);
                setSaveModalMasterWeekSchedule(response);
                setIsLoading(false);
                handleDateComparison(response?.AppointmentDate);
            }).catch((error) => {
                // console.log("error", error);
                setIsLoading(false);
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            });
        }
    }, [ID]);

    return (

        <Modal show={isMasterWeekOpen} onHide={isMasterWeekOpen} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 provider_schedular za-create_master_weekpopup">
            <Modal.Body>
                {DeleteConfirmation}
                {MissedVisitPopup}
                {isLoading ? <Loader /> : <></>}
                <div className='d-flex justify-content-between align-items-center mb-10 px-10' >
                    <p></p>
                    <div className='heading fs-14 '>Add Master Week</div>
                    <div className='d-flex align-items-center gap-2'>
                        {/* <div className='za-tooltip position-relative '>
                            <i className='icon-Icon-material-timelapse' onClick={() => setIsOpenHistory(!isOpenHistory)}></i>
                            {isOpenHistory &&
                                HistoryRecord?.map((item) => {
                                    return (
                                        <div className='za-history-popup position-absolute'>
                                            <p className='heading fs-11'>History</p>
                                            <div className='d-flex flex-column gap-10 mt-12'>
                                                <div className='d-flex gap-1 align-items-center'>
                                                    <p className='text font-m fs-10'>Applied Date Range :</p>
                                                    <p className='text fs-10'>{item?.DOS}</p>
                                                </div>
                                                <div className='d-flex gap-1 align-items-center'>
                                                    <p className='text font-m fs-10'>Applied By :</p>
                                                    <p className='text fs-10'>{item?.AppliedBy}</p>
                                                </div>
                                                <div className='d-flex gap-1 align-items-center'>
                                                    <p className='text font-m fs-10'>Applied At :</p>
                                                    <p className='text fs-10'>{item?.AppliedAt}</p>
                                                </div>
                                                <div className='d-flex gap-10 align-items-center'>
                                                    <p className='text font-m fs-10'>Status :</p>
                                                    <p className='heading fs-10 fst-italic za-schedule'>{item?.Status}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })

                            }
                        </div> */}
                        <i className='icon-Icon-metro-cross' onClick={() => onClose()} ></i>
                    </div>

                </div>
                <div className='za-master_header d-flex align-items-center gap-2 mx-10'>
                    <div className="img-container s-35 circle">
                        {PatientDetails?.ProfilePictureURL ? <img src={PatientDetails?.ProfilePictureURL} alt="" /> :
                            <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${isMale(PatientDetails.Gender) ? 'za-male' : isFemale(PatientDetails.Gender) ? 'za-female' : 'za-others'}`}>
                                <InitialLetters classes={""} name={PatientDetails?.Name} splitBy={' '} />
                            </p>
                        }
                    </div>
                    <div className='w-100'>
                        <p className='heading fs-12'>{PatientDetails?.Name || ""} <span className='text font-m fs-11 ar-light-color'> {`${PatientDetails?.DOB || ""} ${PatientDetails?.Age ? '(' + PatientDetails?.Age + ')' : ""} ${PatientDetails?.Gender || ""}`}</span></p>
                        <div className='d-flex align-items-center justify-content-between'>
                            {PatientDetails?.PatientInsuranceID && !InsuranceEditable && <p className='heading fs-12 drk-green-clr '>{PatientDetails?.InsuranceName}</p>}

                            {/* {InsuranceEditable &&
                            <div className=" d-flex align-items-center gap-2">
                                <div className="input">
                                    <select name="PatientInsuranceID" id="PatientInsuranceID" className="form-control fc-xs" value={PatientDetails?.PatientInsuranceID} onChange={(e) => handleOnChangeInsurance(e)}>
                                        {InsuranceDropDown?.map((item) => {
                                            return (
                                                <option value={item.value}>
                                                    {item.display}
                                                </option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <i className='icon-Icon-metro-cross fs-10 ms-1' onClick={() => setInsuranceEditable(false)}></i>
                            </div>
                        } */}

                            <p className='text fs-12'>Medicaid # <span className='text font-m fs-12'>{PatientDetails?.MedicaidNo || ""}</span></p>
                        </div>
                    </div>
                </div>
                <div className='date_entry ms-10 mt-10 d-flex align-items-center gap-2'>

                    {mainModalMasterWeekSchedule?.PatientAuthorization && <p className='heading fs-12 text-white'>Authorization #: <span className='heading fs-12 text-white'>{mainModalMasterWeekSchedule?.PatientAuthorization}</span></p>}
                    <p className='heading fs-12 text-white'>{(moment(data?.DateValue).isValid() ? (moment(data?.DateValue).format('dddd') + " - ") : "") + (data?.AppointmentDate || "")}</p>

                </div>
                <div className='za-master-content-scroll hover-scrollbar px-10'>
                    <div>

                        <div className="mt-1 d-flex days_header">
                            <div className="col-md-2 ms-2">
                                <p >Start Time</p>
                            </div>
                            <div className="col-md-2 ms-2">
                                <p >End Time </p>
                            </div>
                            <div className="col-md-3 ms-2">
                                <p >Caregiver</p>
                            </div>
                            {/* <div className="col-md-2 ms-1 ">
                                <p >Unit(s)</p>
                            </div> */}
                            <div className='d-flex align-items-center'>
                                {IsRecordExist && <i className='icon-Icon-material-edit fs-10 cursor-pointer' onClick={() => handleEditMode()}></i>}
                            </div>
                            <div className='I_cons align-items-center col-md-2-5 d-flex gap-1 justify-content-end pe-1-5'>
                                <div>
                                </div>
                                <div className="za-denied-status master-week position-relative d-flex">
                                    <i className='icon-Vector15 fs-13'></i>
                                    <p className='xsm_text text-light tool_tip'>Only New and Scheduled visits can be modified or deleted</p>
                                </div>
                                {/* <i className='icon-Icon-material-edit fs-13 ar-light-color'></i> */}
                                {!mainModalMasterWeekSchedule?.ClaimID && <i className='icon-delete text-danger fs-13' onClick={() => handleDelete(PatientAppointmentID)}></i>}
                            </div>
                        </div>

                        <div className={`timing pt-2 pb-2`}>
                            {<div className="mb-2 align-items-center">
                                <div className={`time_slot ps-2`}>
                                    {/* <div className="heading day mon">
                                        <span>MON</span>
                                    </div> */}
                                    <div className={`col-md-2 input ar-multiple-br ${MasterScheduleValidationModal?.StartTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='AppointmentStart'
                                            name='AppointmentStart'
                                            value={mainModalMasterWeekSchedule?.AppointmentStart}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            <option value="" className='text fs-12'>08:00 AM</option>
                                            {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='AppointmentStart'
                                            name='AppointmentStart'
                                            searchValue={mainModalMasterWeekSchedule?.AppointmentStart}
                                            data={TotalTimeArray}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleShiftsSelectedData}
                                            // is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.StartTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.MonStartTime} */}
                                    </div>
                                    <div className={`col-md-2 input ar-multiple-br pe-1 ${MasterScheduleValidationModal?.EndTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='AppointmentEnd'
                                            name='AppointmentEnd'
                                            value={mainModalMasterWeekSchedule?.AppointmentEnd}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            <option value=""></option>
                                            {TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.AppointmentStart, item?.value);
                                            })?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='AppointmentEnd'
                                            name='AppointmentEnd'
                                            searchValue={mainModalMasterWeekSchedule?.AppointmentEnd}
                                            data={TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.AppointmentStart, item?.value);
                                            })}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleShiftsSelectedData}
                                            // is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.EndTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.MonEndTime} */}
                                    </div>
                                    {/* <div className='col-md-1 check_box'>
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center form-check-input p-0'
                                                id="MonChecked"
                                                name="MonChecked"
                                                // value={mainModalMasterWeekSchedule?.MonChecked}
                                                checked={mainModalMasterWeekSchedule?.Auth?.MonChecked}
                                                onChange={(e) => handleOnChangeSchedule(e, true)}
                                            />
                                        </div>
                                    </div> */}
                                    <div className={`input ar-multiple-br col-md-3 ${MasterScheduleValidationModal?.CaregiverID ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='CareGiverID'
                                            name='CareGiverID'
                                            value={mainModalMasterWeekSchedule?.CareGiverID}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            <option value=""></option>
                                            {CareGiverDD?.map((CG) => {
                                                return (
                                                    <>
                                                        <option className='text fs-12' value={CG?.value}>{CG?.display}</option>
                                                    </>
                                                )
                                            })}
                                            <option value={''} className='text fs-12'>HomeCare Agency</option>
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='CareGiverID'
                                            name='CareGiverID'
                                            searchValue={mainModalMasterWeekSchedule?.CareGiver}
                                            data={CareGiverDD}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleShiftsSelectedData}
                                            // is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.CaregiverID ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.MonCaregiverID} */}
                                    </div>

                                    {/* <div className='col-md-3 ms-3'>
                                        <p className='text font-m fs-11'>{mainModalMasterWeekSchedule?.Auth?.Mon}</p>
                                    </div> */}
                                    {/* <div className='col-md-4'>
                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                            <p className='text font-m fs-11 text-nowrap'>Approved: {mainModalMasterWeekSchedule?.Auth?.Wed}</p>
                                            <i className='icon-delete fs-11 text-danger'></i>
                                        </div>
                                    </div> */}
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <div className="modal_footer  ar-border-color br-top-1">
                <div className="text-end">
                    <div className="d-flex justify-content-between align-items-center ar-toggle-button">
                        {isDayPassed && !mainModalMasterWeekSchedule?.ClaimID ?
                            <div class="d-flex gap-2 form-check form-switch radio_button min-h-inherit mb-0 align-items-center">
                                <input class="form-check-input position-static ms-0 mt-0" type="checkbox" name='IsMissVisit' id='IsMissVisit' checked={mainModalMasterWeekSchedule?.IsMissVisit} onChange={(e) => handleOnChangeSchedule(e, true)} />
                                <label class="heading fs-12 " for="mySwitch">Mark As Missed Visit</label>
                            </div>
                            :
                            <span></span>
                        }
                        <div className="btns-group">
                            <button className="btn btn-gray heading fs-12" onClick={() => onClose()}>
                                Cancel
                            </button>
                            <button className="btn btn-orange heading fs-12 text-white" onClick={() => handleSaveMasterWeek()}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>

    )
}

export default DaySchedulePopup
